import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg?.replace("Value error, ", "")).join(", ");
  return d || e?.message || "Something went wrong";
};

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const imgUrl = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export function useAdminApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, opts = {}) => {
      const token = await getToken();
      const res = await api.request({ method, url, data, headers: { Authorization: `Bearer ${token}` }, ...opts });
      return res.data;
    },
    [getToken]
  );
}
